import React from "react";
import { Link } from "react-router-dom";

export function SectionHeader({ overline, title, sub, className = "" }) {
    return (
        <div className={`max-w-3xl ${className}`}>
            {overline && <div className="overline mb-4" data-testid={`overline-${overline.toLowerCase()}`}>{overline}</div>}
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-none">{title}</h2>
            {sub && <p className="mt-6 text-lg text-muted-foreground leading-relaxed">{sub}</p>}
        </div>
    );
}

export function Hero({ overline, title, sub, ctaPrimary, ctaSecondary, image, dark = false, accent = "construction" }) {
    return (
        <section className={`section ${dark ? "bg-foreground text-background" : ""}`} data-testid="page-hero">
            <div className="container-editorial grid md:grid-cols-2 gap-12 md:gap-20 items-center">
                <div className="anim-fade-up">
                    {overline && <div className="overline mb-6" style={{ color: dark ? "rgba(255,255,255,0.6)" : undefined }}>{overline}</div>}
                    <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-none">{title}</h1>
                    {sub && <p className={`mt-6 text-lg leading-relaxed max-w-xl ${dark ? "text-background/70" : "text-muted-foreground"}`}>{sub}</p>}
                    <div className="mt-10 flex flex-wrap items-center gap-3">
                        {ctaPrimary && (
                            <Link
                                to={ctaPrimary.to}
                                data-testid="hero-cta-primary"
                                className={`${false ? "bg-navy text-arch-white" : dark ? "bg-background text-foreground" : "bg-foreground text-background"} px-6 py-3 text-sm hover:opacity-90 transition-opacity`}
                            >
                                {ctaPrimary.label}
                            </Link>
                        )}
                        {ctaSecondary && (
                            <Link
                                to={ctaSecondary.to}
                                data-testid="hero-cta-secondary"
                                className={`border ${dark ? "border-background/40 text-background" : "border-border"} px-6 py-3 text-sm hover:bg-secondary/80 transition-colors`}
                            >
                                {ctaSecondary.label}
                            </Link>
                        )}
                    </div>
                </div>
                {image && (
                    <div className="relative border border-border bg-secondary overflow-hidden aspect-[4/5]">
                        <img src={image} alt="" className="w-full h-full object-cover" />
                    </div>
                )}
            </div>
        </section>
    );
}

export function FeatureGrid({ items }) {
    return (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 border border-border" data-testid="feature-grid">
            {items.map((it, i) => (
                <div key={i} className="p-8 border-b border-r border-border last:border-r-0 md:[&:nth-child(2n)]:border-r-0 lg:[&:nth-child(3n)]:border-r-0">
                    {it.overline && <div className="overline mb-3">{it.overline}</div>}
                    <div className="font-display text-2xl tracking-tight">{it.title}</div>
                    <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{it.body}</p>
                </div>
            ))}
        </div>
    );
}

export function CTAStrip({ title, sub, cta, dark = false }) {
    return (
        <section className={`section ${dark ? "bg-foreground text-background" : "border-t border-border"}`}>
            <div className="container-editorial flex flex-col md:flex-row md:items-end justify-between gap-8">
                <div className="max-w-2xl">
                    <h3 className="font-display text-3xl md:text-4xl tracking-tight leading-none">{title}</h3>
                    {sub && <p className={`mt-4 ${dark ? "text-background/70" : "text-muted-foreground"}`}>{sub}</p>}
                </div>
                {cta && (
                    <Link
                        to={cta.to}
                        data-testid="cta-strip-btn"
                        className={`${dark ? "bg-background text-foreground" : "bg-foreground text-background"} px-6 py-3 text-sm hover:opacity-90 self-start`}
                    >
                        {cta.label}
                    </Link>
                )}
            </div>
        </section>
    );
}
